import RFFInputField from '../../form/RFFInputField';
import msgs from '../../../config/messages';
import { required } from '../../../utils/validationUtils';

export default [
  {
    name: 'username',
    label: msgs.PdmiForm.username,
    placeholder: msgs.PdmiForm.username,
    component: RFFInputField,
    isRequired: true,
    validate: required,
  },
  {
    name: 'password',
    label: msgs.PdmiForm.password,
    placeholder: msgs.PdmiForm.password,
    component: RFFInputField,
    isRequired: true,
    validate: required,
  },
  {
    name: 'passwordConfirmation',
    label: msgs.PdmiForm.passwordConfirmation,
    placeholder: msgs.PdmiForm.password,
    component: RFFInputField,
    isRequired: true,
    validate: required,
  },
];



// WEBPACK FOOTER //
// ./src/components/forms/PdmiForm/formConfig.jsx